import React, { FC, useState } from "react"
import { RRButtonFooter } from "../../atoms/roundedrectangle/RRButtonFooter"
import { Spacer } from "../../atoms/Atoms"
import { RRIconBar } from "../../atoms/roundedrectangle/RRIconBar"
import { RoundedRectangle } from "../../atoms/roundedrectangle/RoundedRectangle"
import { BodyLarge, BodySmall } from "../../atoms/Bodies"
import { CarrotCardModuleProps } from "components/views/molecules/CarrotCardModuleContainer"
import { FormattedMessage } from "react-intl"
import { useFlags } from "launchdarkly-react-client-sdk"
import { RequestCardContainer } from "../../../../pages/request-carrot-card-flow"
import { useDispatch } from "react-redux"
import { fetchReimbursementDetails } from "../../../../actions/reimbursementDetailsActions"

const CarrotCardEligibleModule: FC<CarrotCardModuleProps> = ({ backgroundColor, isVirtualCard }) => {
  const { goldStarRequestCardFlow } = useFlags()
  const [openRequestCardModal, setOpenRequestCardModal] = useState(false)
  const dispatch = useDispatch()

  const toggleRequestCardModal = (event) => {
    event.preventDefault()
    setOpenRequestCardModal(true)
  }

  const onClose = () => {
    dispatch(fetchReimbursementDetails())
    setOpenRequestCardModal(false)
  }

  return (
    <RoundedRectangle backgroundColor={backgroundColor}>
      <RRIconBar iconBackgroundColor="white-60" iconName="icn-carrot-cards" />
      <BodyLarge color="black-80">
        <FormattedMessage defaultMessage="Easily pay for care with Carrot Card®" />
      </BodyLarge>
      <Spacer height={0.5} />
      <BodySmall color="black-80">
        <FormattedMessage defaultMessage="The easiest way to pay for eligible services, debited directly from your account." />
      </BodySmall>
      <RRButtonFooter
        to={goldStarRequestCardFlow ? "" : "/request-card"}
        onClick={goldStarRequestCardFlow ? toggleRequestCardModal : null}
        outline
        id={goldStarRequestCardFlow ? "carrot-card-module-request-card-new" : "carrot-card-module-request-card"}
      >
        {isVirtualCard ? (
          <FormattedMessage defaultMessage="Get virtual card" />
        ) : (
          <FormattedMessage defaultMessage="Request a card" />
        )}
      </RRButtonFooter>
      <RequestCardContainer onOpen={openRequestCardModal} onExit={onClose} />
    </RoundedRectangle>
  )
}

export { CarrotCardEligibleModule }
